import React, { useEffect } from 'react'
import cn from 'classnames'
import { connect } from 'react-redux'

import Navbar from '../containers/Navbar'
import OrdersHeader from '../containers/orders/Header'
import OrdersList from '../containers/orders/List'
import OrdersSidebar from '../containers/orders/Sidebar'

import { orderDetailsRequested} from '../actions/order'

import VNPusher, {
  CHANNEL_PRIVATE_POS_VENUE,
  PUSHER_EVENT_ORDER_MUTATION,
  BIND_ORDERS_MUTATION } from '../pusher'

import styles from './Orders.module.scss'

const Orders = ({ className, onMount }) => {
  const classNames = cn(styles.orders, className)

  useEffect(() => {
    onMount()

    return () => {
      VNPusher.unsubscribe(CHANNEL_PRIVATE_POS_VENUE)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={classNames}>
      <Navbar className={styles.navbar} />

      <div className={styles.content}>
        <div className={styles.ordersContainer}>
          <OrdersHeader className={styles.header} />
          <OrdersList className={styles.list} />
        </div>

        <OrdersSidebar className={styles.sidebar} />
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onMount: () => {
      VNPusher.subscribe(CHANNEL_PRIVATE_POS_VENUE)
      VNPusher.bind(BIND_ORDERS_MUTATION, CHANNEL_PRIVATE_POS_VENUE, PUSHER_EVENT_ORDER_MUTATION, (data) => {
        if (data.mutation_type === "refund" && data.mutation_applied) {
          dispatch(orderDetailsRequested(data.order_uuid))
        }
      })
    }
  }
}

export default connect(null, mapDispatchToProps)(Orders)
